import React from 'react'
import SideMenu from '../core/SideMenu'
import Header from '@/components/core/Header'
import styled from 'styled-components'
import { FadeIn } from '@/lib/css-lib'
import Loading from '@/components/common/Loading'

export interface SideMenuAndContentTemplateProps {
    mainContent: React.ComponentType<any>
    /** メインコンテンツの外枠の装飾設定 (true で装飾なし) */
    plainStyle?: boolean
}

const SideMenuAndContentTemplate: React.FC<SideMenuAndContentTemplateProps> = ({ mainContent, plainStyle }) => {
    const Content = mainContent
    return (
        <Container>
            <HeaderArea>
                <Header />
            </HeaderArea>
            <SideMenuArea>
                <SideMenu />
            </SideMenuArea>
            <MainContentArea>
                <div>
                <React.Suspense fallback={<Loading />}>
                    <FadeIn>
                        {
                            plainStyle ? (
                                <Content />
                            ) :
                            (
                                <MainArea>
                                    <Content />
                                </MainArea>
                            )
                        }
                    </FadeIn>
                </React.Suspense>
                </div>
            </MainContentArea>
        </Container>
    )
}

export default SideMenuAndContentTemplate

const HeaderHeight = '65px';

const Container = styled.div`
    display: grid;
    grid-template-rows: ${HeaderHeight} 1fr;
    grid-template-columns: 250px 1fr;
    grid-template-areas:
        'header header'
        'sidemenu content';

    height: 100vh;
`

const HeaderArea = styled.div`
    grid-area: header;
    box-sizing: border-box;
    background-color: #ffffff;
    width: 100vw;
    z-index: 9999;
`

const SideMenuArea = styled.div`
    grid-area: sidemenu;
    border-right: 1px solid #888;
    height: calc(100vh - ${HeaderHeight});
`

const MainContentArea = styled.div`
    grid-area: content;
    overflow: auto;
    background-color: ${(p) => p.theme.colors.bgMain};
    box-sizing: border-box;
`

const MainArea = styled.div`
    padding: 10px 20px;
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    margin: ${p => p.theme.spaces.large};
`;
